import client from '../httpClient';

const schedulesGetContactsTimeApi = (customerId) => {
  return client.get(`/actions/contacts/time/${customerId}`);
};

export default schedulesGetContactsTimeApi;
